import './styles/about.scss';
import './styles/cssSolarSystem.scss';
import './styles/main.scss';
import './styles/relationshipEditorGOT.scss';
import './styles/relationshipMapGOT.scss';
import './styles/threejsPlanet.scss';
import './styles/transparentImageDemo.scss';


import './scripts/app.js';
import './scripts/services/service-module.js';
import './scripts/controllers/controller-module.js';
import './scripts/root.js';
import './scripts/libraries/OrbitControls.js';

console.log('updated yo');


// WEBPACK FOOTER //
// ./app/app-main.js